import { useAtomValue, useSetAtom } from "jotai";
import type { IconType } from "react-icons";

import type { FilterTypeEnum, Option } from "@sorcery/db";

import { searchJotai, setSearchJotai } from "~/state/searchJotai";
import { FilterItem } from "./FilterItem";

type Props = {
  type: FilterTypeEnum;
  options: Option[];
  IconComponent: IconType;
  iconSize?: number;
};

export const FilterSection = ({ type, options, IconComponent, iconSize = 14 }: Props) => {
  const search = useAtomValue(searchJotai);
  const setSearch = useSetAtom(setSearchJotai);
  const filters = search?.filters.filter((f) => f.type === type) ?? [];

  return (
    <div className="mb-1 flex flex-row items-center">
      <div className="pr-4">
        <IconComponent size={iconSize} className="text-white" />
      </div>

      <div className="flex h-full flex-row">
        {options.map((o) => (
          <ul key={o.label}>
            <FilterItem
              active={!!filters.find((f) => f.value === o.value)}
              label={o.label}
              onClick={() => {
                let newFilters: Option[] = [];
                if (filters.find((f) => f.value === o.value)) {
                  newFilters = filters.filter((f) => f.value !== o.value);
                } else {
                  newFilters = [...filters, o];
                }
                const fullFilters = (search?.filters ?? [])
                  .filter((f) => f.type !== type)
                  .concat(newFilters);

                setSearch({ filters: fullFilters });
              }}
            />
          </ul>
        ))}
      </div>
    </div>
  );
};
